import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { servicedeskProactiveSupportOpenIssuesRoute } from '@jira/router-routes__servicedesk-proactive-support-routes/src/servicedeskProactiveSupportOpenIssuesRoute.tsx';
import { servicedeskProactiveSupportEntryPoint } from '@jira/spa-apps__servicedesk-proactive-support/src/serviceProactiveSupport.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const proactiveSupportPageEntryPoint = createPageEntryPoint({
	main: servicedeskProactiveSupportEntryPoint,
});

export const servicedeskProactiveSupportOpenIssuesRouteEntry: Route = createEntry(
	servicedeskProactiveSupportOpenIssuesRoute,
	() => ({
		group: 'servicedesk',
		ufoName: 'jsm.proactive-support.open-issues',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [...getServiceDeskNavigationResources(), ...getServicedeskPageContextResources()],

		entryPoint: () =>
			fg('jsm_psm_visible') ? proactiveSupportPageEntryPoint : notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
